<template>
  <v-card flat tile>
    <div class="text-center px-2 pb-1" style="opacity: 0.3">
      <div class="heading h2">MOUNT LOCKED</div>
      <div class="text-cc-overline">SUPERHEAVY WEAPON BRACING</div>
    </div>
  </v-card>
</template>

<script lang="ts">
export default {
  name: 'sh-lock-card',
};
</script>
